<template>
<div>
      <v-menu offset-y>
      <v-btn
        slot="activator"
        color="black"
        dark
        small

      >
        {{defaultSelection}} &nbsp; 
         <v-icon small color="white">fa fa-caret-down</v-icon>
                       
      </v-btn>
      <v-list>
        <v-list-tile
          v-for="(item, index) in options"
          :key="index"
          @click="setSelection(item)"
        >
          <v-list-tile-title>
              <v-layout row wrap>
              <v-flex sm2>
              <v-icon v-if="item.name===defaultSelection" small dense color="green">fa fa-check</v-icon>
              </v-flex>
              <v-flex sm10>
              {{ item.name }}
              
              </v-flex>
        </v-layout>
        </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    &nbsp;&nbsp;
    
  
    </div>
</template>
<script>
import UserMenu from './UserMenu.vue'
import TokenService from '@/api/service/TokenService.js';
import UserService from '@/api/service/UserService.js'

export default  {
  components: {
    UserMenu
  },
   data()  { 
      return {
          defaultSelection:'Select Company',
          User:{},
          options:[]
      }
    },
     mounted:function() {
   
         var $options;
         var $selected
         var stores = this.$store
         $options= JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
         //console.log($options)
         this.$store.commit('SET_USER_INFO',$options.data.User)
        // this.User =$options.data.User;
        //console.log(this.$store)
        this.User=this.$store.getters.userInfo
         console.log(this.User)
         this.options= JSON.parse($options.data.User.companyList)
         //console.log(this.options)
         this.options.forEach(function(option) {
             if(option.id==$options.data.User.default_company_id) {
                  stores.commit('SET_DEFAULT_COMPANY',{"id":option.id,"name":option.name})
             }
         });
          this.defaultSelection = this.$store.getters.defaultCompany.name
             
    },
    methods:{
        setSelection(item){
            var $options;
           this.defaultSelection= item.name
            this.$store.commit('SET_DEFAULT_COMPANY',item)
             var stores = this.$store
             $options= JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
             $options.data.User.default_company_id = item.id
              UserService.update({"id":$options.data.User.id,"default_company_id":$options.data.User.default_company_id})
              .then($updated => TokenService.renewToken($options.data.User.id))
              .then(response => {
                localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE,JSON.stringify(response))
                stores.commit('SET_AUTHORIZED_USER', true) 
                stores.commit('SET_USER_INFO',response.data.User)
                if(response.data.User.super_user==1) {

                stores.commit('SET_ADMINISTRATOR', true)
                } else {
                stores.commit('SET_ADMINISTRATOR', false)
                }
                 // window.location.reload();
                  //localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE,JSON.stringify($options))
             window.location.reload()     
              })

            
            //console.log(item)
            //console.log(this.$store.getters.defaultCompany.name)
        }
    }
}
</script>
